export default  {
  name: 'saft',
  props: [],  
  mounted() {
    
  },
  components: { },
  data() {
    return {
      saft: [],
      flag: [],
      countryUS: false,
      modalOne: true,
      showPageTwo: false,
      showPageThree: false,
      showPageFive: false,
      level1: false,
      userdata: [],
      validationMessage: '',
      authData: [],
      successMsg: "",
    }
  },
  methods: {
    locationUpdated(latlng) {
      this.latitude = latlng.lat;
      this.longitude = latlng.lng;
    },
    getCountry() {
      this.$http.get('https://ipinfo.io')
          .then(
          response => {
            if(response.country == "US") {
              console.log("Welcome, American!");
              this.countryUS = true;
          } else {
              console.log("Hello!");
              this.countryUS = false;
              this.showPageTwo = true;
          } },
          error => { console.log("error") })
    }, 
    validateMessage(msg) {
      this.validationMessage = '';
      let valid = true;
      if (msg.name.length < 4) {
        valid = false;
        this.validationMessage += "Name must be longer than 4 symbols";
      } 
      if (msg.address.length < 1) {
        valid = false;
        if (this.validationMessage != '') this.validationMessage += '\n';
        this.validationMessage += "Address must not be empty";
      }
      if (msg.city.length < 1) {
        valid = false;
        if (this.validationMessage != '') this.validationMessage += '\n';
        this.validationMessage += "City must not be empty";
      }
      if (msg.zipcode.length < 2) {
        valid = false;
        if (this.validationMessage != '') this.validationMessage += '\n';
        this.validationMessage += "Zipcode must not be empty";
      }
      if (msg.state.length < 2) {
        valid = false;
        if (this.validationMessage != '') this.validationMessage += '\n';
        this.validationMessage += "State"+this.$gettext('must not be empty');
      }

      // if (msg.phone.length < 4) {
      //   valid = false;
      //   if (this.validationMessage != '') this.validationMessage += '\n';
      //   this.validationMessage += "Phone must not be empty or longer 4 number";
      // }    
      if (!msg.email.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi)) {
        valid = false;
        if (this.validationMessage != '') this.validationMessage += '\n';
        this.validationMessage += "Wrong email!"
      }
      return valid;
    },
    sendData() {
      this.sended = false;
      console.log("okok")
      let addr = this.$refs["address"].value + " " + this.$refs["city"].value + ", " + this.$refs["country"].value + " " + this.$refs["zipcode"].value
      this.userdata = {name: this.$refs["name"].value, "address": addr, email:this.$refs["email"].value};
      let msg = {
        name: this.$refs["name"].value,
        email: this.$refs["email"].value,
        company: this.$refs["company"].value,
        level: this.$refs["level"].value,
        address: this.$refs["address"].value,
        // phone: this.$refs["phone"].value,
        city: this.$refs["city"].value,
        zipcode: this.$refs["zipcode"].value,
        state: this.$refs["state"].value,
        country: this.$refs["country"].value
      }
      if (this.validateMessage(msg)) {

        this.level1 = (this.$refs["level"].value == '0-100 ETH') ? true : false; 
        let message = 'name: ' + msg.name + '\nemail: ' + msg.email + '\ncompany: ' + msg.company + '\nlevel: ' + msg.level + '\naddress: ' + msg.address;
        this.sended = true;
        console.log(msg)
        //setTimeout(() => { this.sended = false; }, 5000)
        this.$http.post('/api/addsaft', { msg })
          .then(
          response => { 
            console.log("SEND") 
            console.log(response)
            this.showPageTwo = false;            
            this.userdata.id = response.body._id;
            if (!this.level1)  this.generateSign();
            this.showPageFive = true;        
          },
          error => { 
            console.log("NO");
            console.log(error)
          })
      }
    },     
    generateSign() {
      console.log("refs - generateSign")
      this.userdata.amount = (this.$refs["amount"]) ? this.$refs["amount"].value : "";
      this.userdata.payment_address = (this.$refs["payment_address"]) ? this.$refs["payment_address"].value : "";
      this.userdata.coin = (this.$refs["payment_address"]) ? this.$refs["coin"].value : "";
      
      console.log("this.userdata>>>>>>>>>>>>")  
      console.log(this.userdata)  
      let data = {};
      data.name = this.userdata.name;  
      data.email = this.userdata.email;
      data.address = this.userdata.address;
      data.payment_address = this.userdata.payment_address;
      data.id = this.userdata.id;
      data.amount = this.userdata.amount;
      data.coin = this.userdata.coin;
      //this.showPageFive = false;
      //this.level1 = false; 
      
      this.$http.post('/api/makePdf', data)
          .then(
          response => { 
            console.log("SEND PDF")
            console.log(this.userdata)
            console.log("SEND PDF RESPONSE") 
            console.log(response)
            // console.log(location.href)
            // data = (this.level1) ? this.firstMsg() : this.secondMsg();

            this.$http.post('/api/sendSaft2', data )
            .then(
              response => {
                // this.sendmail(data);
                setTimeout(() => {
                  var _s = this
                  var url = "/uploads/"+ response.body;
                  this.$localStorage.set('udata', JSON.stringify(this.userdata))
                  this.$router.push({ name: 'Agreement', params: { url: url }})
                }, 1000)
              },
              error => {
                console.log("NO")
                console.log(error)
              })
          },
          error => {
            console.log("NO")
            console.log(error)
          })
    },
    getUserInput() {
        var summary = this.$refs["desc"].value, start = this.$refs["startTime"].value, end = this.$refs["endTime"].value, date = this.$refs["date"].value;

        console.log(this.userdata)
       
         var resource = {
            "summary": summary,
            "start": {
              "dateTime": new Date(date + " " + start).toISOString()
            },
            'attendees': [
               {email: "nadezhda.s@it-dimension.com"}
            ],
            "end": {
              "dateTime": new Date(date + " " + end).toISOString()
              }
            };
        // create the request
        var request = gapi.client.calendar.events.insert({
          'calendarId': 'primary',
          'resource': resource
        });

        // execute the request and do something with response
        request.execute(function(resp) {
          console.log(resp);
          console.log("Your event was added to the calendar.");
          var div = document.createElement("div"), cMsg = document.getElementById("contactMsg");
          div.innerHTML = "Your event was added to the calendar.";
          div.setAttribute("id", "successMsg");
          div.style.color = "green";

          cMsg.parentElement.removeChild(cMsg);
          
          var content = document.getElementById("content");
          content.parentElement.replaceChild(div, content);

          //alert("Your event was added to the calendar.");"dateTime": "2017-10-31T17:00:00-07:00"
        });
    },
  },
  beforeMount() {
     this.getCountry();
  },
  computed: {

  },
  created() {
    this.countries = require('./../../data/country.js');
    this.flag = require('./../../data/flag.js');

  }
}




// WEBPACK FOOTER //
// ./src/components/Saft/Saft.component.js